import { ReactNode } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { TenantProvider } from '../contexts/TenantContext'
import { AuthProvider } from '../contexts/AuthContext'
import { AdminSocketProvider } from '../contexts/AdminSocketContext'
import { GoogleMapsProvider } from '@tenant/shared-ui'
import { Toaster } from 'sonner'

type AppProvidersProps = {
  children: ReactNode
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 2,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: (failureCount, error: any) => {
        // Biznes xətalarını (4xx) təkrarlama — təkrar mənasızdır
        const status = error?.response?.status
        if (status && status >= 400 && status < 500) return false
        return failureCount < 1
      },
    },
  },
})

export function AppProviders({ children }: AppProvidersProps) {
  const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || ''

  return (
    <QueryClientProvider client={queryClient}>
      {/* TenantProvider must wrap AuthProvider — AuthProvider reads
          storage.authToken which requires window.__TENANT_SLUG__ to be set. */}
      <TenantProvider>
        <AuthProvider>
          <Router>
            <AdminSocketProvider>
              <GoogleMapsProvider apiKey={apiKey} language="az" libraries={['places', 'geometry', 'drawing']}>
                {children}
                <Toaster position="top-right" richColors />
              </GoogleMapsProvider>
            </AdminSocketProvider>
          </Router>
        </AuthProvider>
      </TenantProvider>
    </QueryClientProvider>
  )
}


